<template>
    <a-modal
      class="take-photo-modal"
      :visible="show"
      :title="$t('personalManaEdit.takePhotoModal')"      
      :width="410"
      :maskClosable="false"
      :footer="null"      
      :afterClose="webCamReset"
      @cancel="handleHideModal"
    >  
      <div style="text-align: center;position: relative;">
        <div v-show="!spotPhotoBase64" class="camera-warp">
          <div id="camera-obj"></div>
        </div>
        <img v-show="spotPhotoBase64" class="perview-photo" :src="spotPhotoBase64" />

        <a-row class="camera-operation-btn-area" type="flex" justify="center" align="middle">
          <a-col>
            <a-button
              shape="circle"
              type="primary"
              ghost
              size="large"
              :disabled="!freeze || spotPhotoUploading"
              @click="webCamUnFreeze"
            >
              <a-icon type="redo" />
            </a-button>
          </a-col>
          <a-col>
            <a-button
              class="take-photo-btn"
              shape="circle"
              type="primary"
              size="large"
              :disabled="freeze"
              @click="webCamFreeze"
            >
              <a-icon type="camera" />
            </a-button>
          </a-col>
          <a-col>
            <a-button
              shape="circle"
              type="primary"
              ghost
              size="large"
              :loading="spotPhotoUploading"
              :disabled="!freeze"
              @click="webCamTakePhoto"
            >
              <a-icon v-if="!spotPhotoUploading" type="check" />
            </a-button>
          </a-col>
        </a-row>
      </div>
    </a-modal>
</template>

<script>
import WebCam from './WebCam.js'
import { uploadBase64Img } from '@/api/fileUpload.js';
import { compressImageFile } from '../../utils/utils';
import * as imageConversion from 'image-conversion';

export default {
  name: 'Camera',
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      freeze: false,

      // 点击拍照后，用canvas截图生成的图片base64
      spotPhotoBase64: '', 
      spotPhotoUploading: false
    }
  },
  computed: {},
  watch: {
    show: function(show) {
      if (show) this.webCamOpen()
    }
  },
  destroyed() {
    WebCam.reset()
  },
  methods: {
    // 打开摄像头
    webCamOpen() {
      this.$nextTick(() => {
        WebCam.set({
          constraints: {
            width: 360,
            height: 480
          },
          width: 360,
          height: 480,
          image_format: 'jpeg',
          jpeg_quality: 100,
          swfURL: process.env.BASE_URL + 'webcam.swf'
        });
        WebCam.attach('#camera-obj');
      })
    },
    // 模态框关闭后，关闭摄像头
    webCamReset() {
      this.webCamUnFreeze()
      this.spotPhotoBase64 = ''
      WebCam.reset()
      
    },
    // 点击拍照按钮，冻结摄像头
    webCamFreeze() {
      WebCam.freeze()
      this.freeze = true
    },
    // 点击重新拍照按钮，解冻摄像头
    webCamUnFreeze() {
      WebCam.unfreeze()
      this.freeze = false
    },
    // 点击确定按钮，拍摄照片并上传
    webCamTakePhoto() {
      // WebCam.snap(this.handleSubmitPhoto)
      WebCam.snap(async (base64, canvas) => {
        const file = await imageConversion.canvastoFile(canvas)
        compressImageFile(file, this.uploadPhoto)
      })
    },
    // 提交拍摄照片
    async uploadPhoto(image) {
      try {
        this.spotPhotoUploading = true;
        this.spotPhotoBase64 = image.base64;

        const base64Unhead = image.base64.replace(/^data:image\/\w+;base64,/, '');
        const res = await uploadBase64Img({ data: base64Unhead, suffix: 'jpg' });

        this.spotPhotoUploading = false
        this.$emit('afterUploadPhoto', res)
        this.handleHideModal()
      } catch (error) {
        this.spotPhotoUploading = false;
      }
    },

    handleHideModal() {
      this.$emit('hideModal', false)
    }
  }
}
</script>

<style scoped>
.take-photo-modal .perview-photo {
  width: 360px;
  height: 480px;
  margin: 0 auto;
}
.take-photo-modal .camera-operation-btn-area {
  margin-top: 16px;
}
.take-photo-modal .camera-operation-btn-area .ant-btn {
  margin: 0 20px;
  width: 50px;
  height: 50px;
  font-size: 24px;
}
.take-photo-modal .camera-operation-btn-area .take-photo-btn {
  width: 70px;
  height: 70px;
  font-size: 36px;
}

.take-photo-modal .camera-warp {
  width: 360px;
  height: 480px;
}
</style>
